import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface DropdownMenuItem {
  label: string;
  icon?: string;
  route?: string | any[];
  disabled?: boolean;
  action?: () => void;
}

@Component({
  selector: 'molecule-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss'],
})
export class DropdownMenuComponent implements OnInit {
  @Input() label = '';
  @Input() icon = 'expand_more';
  @Input() items: DropdownMenuItem[] = [];
  @Output() itemClick = new EventEmitter<DropdownMenuItem>();

  ngOnInit() {}

  onItemClick(item: DropdownMenuItem): void {
    item.action?.();
    this.itemClick.emit(item);
  }
}
